import { TopNav, PageShell, BackCoverFooter, BrutalistBadge } from "@/app/components/brand-scaffold";
import { siteHeaderActionsEn, siteNavItemsEn } from "@/app/content-en";

export default function MarketplaceRoadmapPageEn() {
  return (
    <PageShell>
      <TopNav navItems={siteNavItemsEn} actionItems={siteHeaderActionsEn} homeHref="/en" />
      <main className="relative z-10 w-full overflow-hidden px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
        <div className="mx-auto max-w-4xl">
          <div className="mb-8">
            <BrutalistBadge bgClass="bg-[#14B8A6]" hoverBgClass="hover:bg-black" hoverTextClass="hover:text-white" className="text-white">
              ROADMAP
            </BrutalistBadge>
          </div>
          <h1 className="text-4xl sm:text-5xl font-black text-black mb-4">
            Marketplace Roadmap
          </h1>
          <p className="text-lg font-bold text-zinc-600 mb-8">
            The evolution path from Preview catalog to public launch.
          </p>
          <div className="border-4 border-black bg-[#FACC15]/20 p-4 mb-12 shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]">
            <p className="text-sm font-bold text-zinc-800">
              ⚠️ Timelines and metrics below are planning targets, not commitments. Actual progress depends on protocol stability and early-user feedback.
            </p>
          </div>

          <div className="space-y-8">
            {roadmapPhases.map((phase) => (
              <div key={phase.title} className={`border-4 border-black p-6 shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] ${phase.bg}`}>
                <div className="flex items-center gap-3 mb-3">
                  <span className={`px-2 py-0.5 text-[10px] font-black uppercase ${phase.statusBg}`}>{phase.status}</span>
                  <h2 className="text-xl font-black">{phase.title}</h2>
                </div>
                <p className="text-sm text-zinc-700 mb-3">{phase.desc}</p>
                <ul className="space-y-1">
                  {phase.items.map((item) => (
                    <li key={item} className="text-sm text-zinc-600">• {item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-12 border-l-8 border-black pl-5">
            <p className="text-base font-bold text-zinc-800">
              All mock data and metric targets above are for illustrative purposes only. Real operational data will be shown after public launch.
            </p>
          </div>
        </div>
      </main>
      <BackCoverFooter />
    </PageShell>
  );
}

const roadmapPhases = [
  {
    title: "Phase 0 · Preview Catalog",
    status: "Current",
    statusBg: "bg-[#A3E635] text-black",
    bg: "bg-[#A3E635]/10",
    desc: "Showcase example Hotlines; validate contract structure and discovery.",
    items: [
      "Example Hotlines demonstrating catalog structure",
      "Contract field completeness validation",
      "Responder view and version management UI",
      "No real calls, no settlement, no ratings",
    ],
  },
  {
    title: "Phase 1 · Closed Beta",
    status: "Planned",
    statusBg: "bg-[#FACC15] text-black",
    bg: "bg-white/85",
    desc: "Invite-only access for the first Responders to list real Hotlines.",
    items: [
      "Review process goes live",
      "Real call pipeline connected end-to-end",
      "Internal Call Credit metering",
      "First real result_package data",
    ],
  },
  {
    title: "Phase 2 · Public Publishing",
    status: "Future",
    statusBg: "bg-white/80 text-black border border-black",
    bg: "bg-white/85",
    desc: "Open publishing—any Responder passing review can list.",
    items: [
      "Public registration and review",
      "Ratings and call history made public",
      "Search and category-based discovery",
      "Self-service Caller onboarding",
    ],
  },
  {
    title: "Phase 3 · Settlement Network",
    status: "Future",
    statusBg: "bg-white/50 text-black/70 border border-black/30",
    bg: "bg-white/85",
    desc: "Fiat settlement and withdrawal go live.",
    items: [
      "Fiat top-up and withdrawal",
      "Automated settlement and reconciliation",
      "Responder revenue dashboard",
      "Tax and compliance integration",
    ],
  },
];
